export enum BasketServiceEndpoints {
    PostCreateBasket = '/v1/basket',
    PostAddUserToBasket = 'v1/basket/{id}/user',
    UpdateBasket = 'v1/basket/{id}',
    GetBasket = 'v1/basket/{id}',
    SignAgreements = 'v1/basket/{id}/sign-agreements',
    PostAddRoommatesToBasket = 'v1/basket/{id}/room-mates',
}
